import { render, staticRenderFns } from "./echartBuycount.vue?vue&type=template&id=a0f5bab4"
import script from "./echartBuycount.vue?vue&type=script&lang=js"
export * from "./echartBuycount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports